import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { id } from '@swimlane/ngx-charts';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { InventoryService } from 'src/app/_services/inventory.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ProductService } from 'src/app/_services/product.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { AppComponent } from 'src/app/app.component';

@Component({
    selector: 'app-utilize-from-bin',
    templateUrl: './utilize-from-bin.component.html',
    styleUrls: ['./utilize-from-bin.component.scss'],
    standalone: false
})
export class UtilizeFromBinComponent extends SubscriptionUtil implements OnInit, OnDestroy {
 product: any = {
  id: null,
    product: {},
    unitPrice: null,
    transferBinType: "LOCATION_BIN",
    transferFromBin: { id: null },
    quantity: 1,
    jobOrder: { id: null },
    quantityUtilized: null,
    tmplTask:null
  };
addProductForm!: UntypedFormGroup;
submitTouched!: boolean;
comingFrom1 = false;
  showBinTransferTable: boolean;
  selectedBinTransfer: any = null;
  translate: any;

  binPickList!: any[];
  filteredBinPickList: any[] = [];
  data: any;
  quantity: any=0;
  constructor(
    public modalRef : BsModalRef,
    private errorUtil: ErrorUtil,
    private spinner: NgxSpinnerService,
    private util: UtilServiceService,
    private languageTranslateService: LanguageTranslateService,
    private inventoryServices: InventoryService,
    private productService: ProductService,) { 
         super();

         this.addProductForm = new UntypedFormGroup({
          quantityUtilized: new UntypedFormControl(null, [
            Validators.required,
            Validators.pattern(AppComponent.validPricePattern),
          ]),
          transferBinType: new UntypedFormControl(null, [Validators.required]),
        });

      }

  ngOnInit(): void {
    console.log("product in utilize from bin",this.data)
    this.product.id = this.data.id;
    this.product.product.id = this.data.product.id;
    this.product.unitPrice = this.data.unitPrice;
    this.product.jobOrder.id = this.data.jobOrderId;
    this.product.tmplTask = this.data.tmplTask;
    this.product.quantity = this.data.quantity || 0;
    
    this.getLanguageData();
    //  if (this.data.transferFromBin == null) {
    //               this.product.transferFromBin = { id: null };
    //               this.addProductForm.controls.transferBinType.enable();
    //               this.comingFrom1 = false;
    //             } else {
                   this.addProductForm.controls.quantityUtilized.disable();
    //               this.comingFrom1 = true;
    //             }

  }
  /******************************************** Get language data ******************************************/
  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
      
      }
    }))
    console.log("translate",this.translate)
  }
  /******************************************** Change status of bin type ******************************************/
push(obs: any) {
    super.push(obs);
  }
  
   /******************************************** show bin transfer table ******************************************/
  public displayBinTransferTable() {
    this.showBinTransferTable = true;
  }

  /******************************************** close bin tranfer table ******************************************/
  public closeBinTransferTable() {
    this.showBinTransferTable = false;
  }
/******************************************** on get bin transfer table ******************************************/
  public gotFromBin($event: any) {
    this.product.transferFromBin.id = $event.id;
    this.quantity = $event.qty;
     this.addProductForm.controls.quantityUtilized.enable();
    this.selectedBinTransfer = $event;
  }
    /******************************************** clear bin transfer ******************************************/
  public clearBinTransfer() {
    this.product.transferFromBin = { id: null };
    this.selectedBinTransfer = null;
  }

  /******************************************** on bin transfer table ******************************************/
  public gotBinTransferAtTable($event: any) {
    this.product.transferFromBin.id = $event.id;
    this.selectedBinTransfer = $event;
    this.quantity = $event.qty;
    this.addProductForm.controls.quantityUtilized.enable();

    this.closeBinTransferTable();
  }
  /******************************************** autocomplete for bin transfer results ******************************************/
  public getAllFromBin($event: any) {
    const query = $event.query.toLowerCase() as string;

    if (query && query.length > 2) {
      const filter = this.binPickList.filter((bin) => {
        const displayName = bin.binDisplayName.toLowerCase() as string;

        if (displayName.includes(query)) {
          return true;
        }

        return false;
      });

      this.filteredBinPickList = [...filter];
    } else {
      this.filteredBinPickList = [...this.binPickList];
    }
  }

  /******************************************** on change status ******************************************/
  public changeStatus(status: any, type: any) {
    console.log(status);
    
    this.product.transferBinType = status;

    return new Promise<void>((resolve) => {
      if (type == "change") {
        this.binPickList = [];
        this.product.transferFromBin = { id: null };
      }
      let productId = "";
      if (this.product.product.id != undefined) {
        productId = this.product.product.id;
      }

      if (productId) {
        if (status == "LOCATION_BIN") {
          this.push(
            this.inventoryServices
              .getFromBinByProduct("location", productId)
              .subscribe((res: any) => {
                this.binPickList = res;

                resolve();
              })
          );
        } else {
          this.push(
            this.inventoryServices
              .getFromBinByProduct("user", productId)
              .subscribe((res: any) => {
                this.binPickList = res;

                resolve();
              })
          );
        }
      }
    });
  }

  /******************************************** submit data ******************************************/
  public onSubmit() {
    this.spinner.show();

    this.submitTouched = true;

    if (!this.addProductForm.valid) {
      console.log(this.addProductForm);

      for (let i in this.addProductForm.controls) {
        this.addProductForm.controls[i].markAsTouched();
      }
      this.submitTouched = false;

      this.spinner.hide();

      return false;
    }

    let formData: any = {
      quantity: this.product.quantity,
      quantityUtilized: this.product.quantityUtilized,
      product: {
        id: this.product.product.id,
      },
      jobOrder: { id: this.product.jobOrder.id },
      unitPrice: this.product.unitPrice,
      transferFromBin: this.product.transferFromBin,
      transferBinType: this.product.transferBinType,
      id: this.product.id,
      tmplTask: this.product.tmplTask
    };
   
   

        this.productService.createJobOrderProductForJO2(formData).subscribe(
          (res: any) => {
            this.spinner.hide();
            if (res.status === 200 || res.status === 201) {
             
              this.errorUtil.setErrorMessage(
                200,
                this.translate?.general.messages.savedSuccessfully,
                null,
                "success",
                3000
              );

              this.modalRef.hide();
            }
          },
          (err) => {
            this.spinner.hide()
           const title = this.errorUtil.processErrorTitle(err.error,this.translate)
           this.errorUtil.setErrorMessage(400, null ,  title, 'error',3000);
          
        }
        )
      
   
  }

}
